import { useCallback, useEffect, useState } from "react";
import { fetchVideoReviewInfo } from "../utils/videoReviewApi";

export function useVideoReviewPayload(token) {
    const [state, setState] = useState({ status: "loading", payload: null });
    const [reloadKey, setReloadKey] = useState(0);

    const reload = useCallback(() => {
        setReloadKey((key) => key + 1);
    }, []);

    useEffect(() => {
        let cancelled = false;
        setState({ status: "loading", payload: null });
        fetchVideoReviewInfo(token)
            .then((payload) => {
                if (cancelled) {
                    return;
                }
                setState(
                    payload
                        ? { status: "ready", payload }
                        : { status: "invalid", payload: null }
                );
            })
            .catch((error) => {
                if (cancelled) {
                    return;
                }
                if (error?.code === "EXPIRED") {
                    setState({ status: "expired", payload: null });
                } else {
                    setState({ status: "error", payload: null });
                }
            });
        return () => {
            cancelled = true;
        };
    }, [token, reloadKey]);

    return { ...state, reload };
}

export default useVideoReviewPayload;
